<template>
  <div>
      <a-upload-dragger class="segments-uploader" :before-upload="beforeUpload" :fileList="fileList" :multiple="false"
        :remove="handleRemove" accept=".csv,.txt" :disabled="loading">
        <div>
          <div>
            <a-icon :type="loaderIcon" class="text-primary" style="font-size: 48px" />
            <div>
              Click or drag .csv or .txt file to this area to upload<br />
              <span class="text">Maximum file size: 10MB</span><br />
            </div>
          </div>
        </div>
      </a-upload-dragger>
    <hr>
    <a-row>
      <a-col class="text-right" :span="24">
        <a-button @click="closeModal">
          Cancel
        </a-button>
        <a-button type="primary" style="margin-left: 10px;" @click="onSubmit" :loading="loading" :disabled="!importFile">
          Add
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>
<script>

import CollectionsService from '@/services/api/apiCollectionsService'

export default {
  name: 'ImportCollectionItemsModal',
  components: {
  },
  props: {
    collectionId: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      importFile: null,
      fileList: null,
    }
  },
  computed: {
    loaderIcon() {
      return this.loading ? 'loading' : this.importFile ? 'check' : 'inbox'
    },
  },
  mounted() {
  },
  methods: {
    beforeUpload(file) {
      this.loading = true
      this.importFile = file
      this.loading = false
      return false
    },
    handleRemove() {
      this.importFile = null
    },
    closeModal() {
      this.$emit('closeImportModal')
    },
    async onSubmit() {
      return await this.importItems()
    },
    async importItems() {
      this.loading = true

      const file = this.importFile
      if (file.size / 1024 / 1024 > 10) {
        this.$notification.error({
          message: 'Error while importing collection items',
          description: 'File is too heavy (max 10MB)',
        })
        this.loading = false
        return
      }
      try {
        const collectionImportResponse = await CollectionsService.uploadCollectionItems(file, this.collectionId)

        if (collectionImportResponse.data?.error) {
          this.$notification.error({
            message: 'Something went wrong',
            description: collectionImportResponse.data.error.message,
          })
          return
        }

        if (collectionImportResponse.data) {
          this.$notification.success({
            message: 'Items were successfully imported',
          })
          this.$emit('addNewItems', collectionImportResponse.data.data)
        }
      } catch (err) {
        this.$notification.error({
          message: 'Something went wrong',
          description: err.response.data.error.message,
        })
        console.log(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style scoped lang="scss">
.add-segments {
  .segments-uploader {
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: auto;
    position: relative;

    .ant-upload-list-item-name {
      color: #1890ff;
    }

  }

  .ant-form-item-label {
    padding: 0px !important;
  }
}
</style>
